/**
 * Quick & dirty setup of a base API service for Timely API.
 * Re-visit this + TIC approach when actually using the RTK slice.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// initialize an empty api service that we'll inject endpoints into later as needed
export const timelyCreateApiBase = createApi({
  reducerPath: 'timelyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.timelyapp.com/1.1',
  }),
  tagTypes: [],
  endpoints: build => ({}),
});
